/* global window */

export function isMacOS() {
  return window.navigator.userAgent.indexOf('Macintosh') !== -1;
}
